import { observer } from 'mobx-react-lite';
import {
  BetStatus,
  convertAmount,
  ListElemText,
  ListItem,
  ListItemCell,
  ListItemCont,
} from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../../enums';

export const LiveBetsItems = observer(({ data: bet, t }) => {
  const { Me } = globalTranslationKeys;
  const {
    betData: { start, end },
  } = bet;
  const betType = +start === +end ? start : `${start} - ${end}`;

  return (
    <ListItemCont
      key={`${bet?.id}`}
      forRemove={bet.status === BetStatus.Lose || bet.winAmount}
      animationDelayInSeconds={1.5}
    >
      <ListItem active={bet.winAmount}>
        <ListItemCell>
          <ListElemText toCapitalize>{t(Me)}</ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText>
            {bet?.freeBetId ? t(globalTranslationKeys.FreeBet) : convertAmount(Number(bet?.amount))}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText className='to-lowercase'>
            {/* {bet.status === BetStatus.Pending ? betType : `x${parseNumberByPrecision(bet.odd, 1, 2)}`} */}
            {betType}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText>
            {(bet?.status || bet?.Status) === BetStatus.Pending
              ? '...'
              : convertAmount(+bet.winAmount)}
          </ListElemText>
        </ListItemCell>
      </ListItem>
    </ListItemCont>
  );
});
